@if (transition.visible()) {
<div class="brand-switch-overlay fixed inset-0 z-50 flex items-center justify-center bg-zinc-100 dark:bg-zinc-950"
  role="status" aria-live="polite" [attr.aria-label]="'Switching to ' + (transition.brandName() || 'selected brand')">
  <div class="brand-switch-logo flex flex-col items-center justify-center">
    @if (logoSrc()) {
    <img [src]="logoSrc()" [alt]="transition.brandName() || 'Brand logo'"
      class="size-24 rounded-2xl object-cover shadow-lg" />
    } @else if (transition.brandName()) {
    <p class="text-xl font-semibold text-primary">{{ transition.brandName() }}</p>
    }
  </div>
</div>
}
